import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { setCookie } from '@client/services/cookies'
import configureStore from './app/store/configureStore'

import env from './server/config/env'
import App from './app/App'

const store = configureStore(window.preloadedReduxState || {})

const { application } = store.getState()

setCookie('debug_country_code', application.debugCountryCode || 'ip_not_found')
setCookie('country_code', application.country)
setCookie('language_code', application.language)

const messages = window.translation

const i18n = {
  language: application.language,
  messages,
}

hydrate(
  <Provider store={store}>
    <BrowserRouter basename={env.contextRoot}>
      <App i18n={i18n} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept()
}
